export default "__VITE_ASSET__3a6fbe6f__"